/**
 * URLパラメーターによるブランド判定
 */
function initBrandSwitchFromURL() {
  // 除外パス（デフォルトヘッダーを使用するページ）
  const excludedPaths = [
    '/apps/obake/',
    '/apps/storecrm/'
  ];

  // 現在のパスが除外リストに含まれているかチェック
  const shouldUseDefaultHeader = excludedPaths.some(function(path) {
    return window.location.pathname.includes(path);
  });

  if (shouldUseDefaultHeader) {
    // console.log('ℹ️ 除外パス検出 - デフォルトヘッダーを使用:', window.location.pathname);
    return; // 処理を中断
  }

  // URLパラメーターを取得
  const urlParams = new URLSearchParams(window.location.search);
  const labelParam = urlParams.get('label');

  // Staff Startページかどうかを確認
  const isStaffStartPage = window.location.pathname.includes('/apps/staffstart/');

  if (labelParam) {
    const label = labelParam.toLowerCase();

    // bodyにブランドクラスを追加
    if (label.includes('anemone')) {
      document.body.classList.add('brand-anemone');
    } else if (label.includes('siena')) {
      document.body.classList.add('brand-siena');
    } else if (label.includes('mimi33') || label.includes('mimi-33')) {
      document.body.classList.add('brand-mimi33');
    } else if (label.includes('itsti') || label.includes('it-sti')) {
      document.body.classList.add('brand-itsti');
    } else if (label.includes('too')) {
      document.body.classList.add('brand-too');
    } else if (label.includes('mrmimi') || label.includes('mr-mimi')) {
      document.body.classList.add('brand-mrmimi');
    }

    // ヘッダー・フッターを再レンダリング（必要に応じて）
    triggerBrandSwitch(label);
  } else {

    // Staff Startページで label がない場合、デフォルトヘッダーを表示
    if (isStaffStartPage) {
      showDefaultHeader();
    }
  }
}

// 即座に実行（bodyクラス追加のため）
initBrandSwitchFromURL();

/**
 * スタッフスタートページで言語切り替えを無効化
 * URLが /apps/staffstart/ を含む場合、言語切り替えによるURL変更を防ぐ
 */
function disableLanguageSwitchOnStaffStart() {
  // スタッフスタートページかどうかをチェック
  if (!window.location.pathname.includes('/apps/staffstart/')) {
    return; // スタッフスタートページでない場合は何もしない
  }

  console.log('🚫 [Staff Start] 言語切り替えを無効化します');

  // bodyにクラスを追加して、CSSで言語切り替えボタンを非表示にする
  document.body.classList.add('staffstart-page');

  // ==========================================
  // 言語プレフィックス付きURLから元のURLへリダイレクト
  // ==========================================
  (function redirectToDefaultLocale() {
    const pathname = window.location.pathname;
    const search = window.location.search; // クエリパラメータ
    const hash = window.location.hash; // ハッシュ

    // 言語プレフィックスのパターン（/en/, /ja/, /fr/ など）
    const localePattern = /^\/([a-z]{2}(-[A-Z]{2})?)\/apps\/staffstart\//;
    const match = pathname.match(localePattern);

    if (match) {
      const localePrefix = match[1]; // 例: "en" または "en-US"
      console.log('🔄 [Staff Start] 言語プレフィックス検出:', localePrefix);

      // 言語プレフィックスを削除した新しいパス
      const newPathname = pathname.replace(/^\/[a-z]{2}(-[A-Z]{2})?\//, '/');
      const newUrl = newPathname + search + hash;

      console.log('🔄 [Staff Start] リダイレクト:', window.location.href, '→', newUrl);

      // リダイレクト実行
      window.location.replace(newUrl); // replace を使用して履歴を残さない
      return;
    }

    console.log('✅ [Staff Start] 言語プレフィックスなし - リダイレクト不要');
  })();

  // localization-form 要素を監視
  document.addEventListener('DOMContentLoaded', function() {
    // すべての localization-form を取得
    const localizationForms = document.querySelectorAll('localization-form');

    if (localizationForms.length > 0) {
      console.log('📍 [Staff Start] localization-form発見:', localizationForms.length + '個');

      localizationForms.forEach(function(formElement) {
        // form要素を取得
        const form = formElement.querySelector('form');

        if (form) {
          // フォーム送信イベントをキャンセル
          form.addEventListener('submit', function(e) {
            console.log('🚫 [Staff Start] 言語切り替えフォーム送信をキャンセル');
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }, true); // キャプチャフェーズで捕捉

          console.log('✅ [Staff Start] フォーム送信イベントをブロック');
        }

        // リンク・ボタンのクリックイベントもキャンセル
        const links = formElement.querySelectorAll('a, button');
        links.forEach(function(link) {
          link.addEventListener('click', function(e) {
            console.log('🚫 [Staff Start] 言語切り替えリンククリックをキャンセル');
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            // ユーザーに通知（オプション）
            // alert('スタッフスタートページでは言語切り替えはご利用いただけません');

            return false;
          }, true); // キャプチャフェーズで捕捉
        });
      });
    }

    // 言語切り替えボタンも無効化（見た目を変更）
    const languageButtons = document.querySelectorAll('.header__btn-language, .mobile-language-toggle');
    languageButtons.forEach(function(btn) {
      btn.style.opacity = '0.5';
      btn.style.cursor = 'not-allowed';
      btn.style.pointerEvents = 'none';
      console.log('✅ [Staff Start] 言語切り替えボタンを無効化');
    });
  });

  // MutationObserverで動的に追加されるフォームも監視
  const observer = new MutationObserver(function(mutations) {
    if (window.location.pathname.includes('/apps/staffstart/')) {
      const localizationForms = document.querySelectorAll('localization-form form');
      localizationForms.forEach(function(form) {
        if (!form.dataset.staffstartDisabled) {
          form.dataset.staffstartDisabled = 'true';

          form.addEventListener('submit', function(e) {
            console.log('🚫 [Staff Start] 言語切り替えフォーム送信をキャンセル（動的）');
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }, true);

          console.log('✅ [Staff Start] 動的に追加されたフォームを無効化');
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// スタッフスタートページでの言語切り替えを無効化
disableLanguageSwitchOnStaffStart();

// DOMContentLoaded後にも実行（ヘッダー切り替えのため）
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBrandSwitchFromURL);
} else {
  // 既にDOMが読み込まれている場合
  setTimeout(initBrandSwitchFromURL, 100);
}

// window.load後にも実行（念のため）
window.addEventListener('load', function() {
  setTimeout(initBrandSwitchFromURL, 300);
});

function triggerBrandSwitch(label) {
  // 既存のヘッダー要素を探す
  const header = document.querySelector('header');
  const footer = document.querySelector('footer');

  if (header) {
    // ブランド用のdata属性を追加
    header.setAttribute('data-brand', label);
  }

  if (footer) {
    footer.setAttribute('data-brand', label);
  }

  // ヘッダーセクションの切り替え
  switchHeaderByBrand(label);

  // カスタムイベントをディスパッチ（他のスクリプトが反応できるように）
  const event = new CustomEvent('brandSwitch', {
    detail: { brand: label }
  });
  document.dispatchEvent(event);

}

function switchHeaderByBrand(label) {
  // すべてのブランドヘッダーを探す
  const allBrandHeaders = document.querySelectorAll('.brand-header');


  if (allBrandHeaders.length === 0) {
    console.warn('⚠️ ブランドヘッダーが見つかりません。通常のページである可能性があります。');
    return;
  }

  // 対象のブランドヘッダーを特定
  let targetBrand = '';

  if (label.includes('anemone')) {
    targetBrand = 'anemone';
  } else if (label.includes('siena')) {
    targetBrand = 'siena';
  } else if (label.includes('mimi33')) {
    targetBrand = 'mimi33';
  } else if (label.includes('itsti')) {
    targetBrand = 'itsti';
  } else if (label.includes('too')) {
    targetBrand = 'too';
  } else if (label.includes('mrmimi')) {
    targetBrand = 'mrmimi';
  }

  // すべてのブランドヘッダーを非表示にし、内部のheader要素のIDを削除
  allBrandHeaders.forEach(function(brandHeaderDiv) {
    const brand = brandHeaderDiv.getAttribute('data-brand');
    const isTarget = brand === targetBrand;

    if (isTarget) {
      // 対象のヘッダーを表示
      brandHeaderDiv.style.display = 'block';

      // header要素のIDを復元（'header'に設定）
      const headerElement = brandHeaderDiv.querySelector('header');
      if (headerElement) {
        headerElement.id = 'header';
      }
    } else {
      // 非表示にして、header要素のIDを削除
      brandHeaderDiv.style.display = 'none';

      const headerElement = brandHeaderDiv.querySelector('header');
      if (headerElement && headerElement.id === 'header') {
        headerElement.removeAttribute('id');
      }
    }
  });

  // ターゲットが見つからない場合
  if (!targetBrand) {
    showDefaultHeader();
  } else {
    const targetHeader = document.querySelector('.brand-header[data-brand="' + targetBrand + '"]');
    if (!targetHeader) {
      console.warn('⚠️ ヘッダーが見つかりません:', targetBrand);
      showDefaultHeader();
    }
  }
}

function showDefaultHeader() {
  const allBrandHeaders = document.querySelectorAll('.brand-header');

  // すべてのブランドヘッダーを非表示にし、header要素のIDを削除
  allBrandHeaders.forEach(function(brandHeaderDiv) {
    const brand = brandHeaderDiv.getAttribute('data-brand');

    if (brand === 'default') {
      // デフォルトヘッダーを表示
      brandHeaderDiv.style.display = 'block';

      // header要素のIDを復元
      const headerElement = brandHeaderDiv.querySelector('header');
      if (headerElement) {
        headerElement.id = 'header';
      }
    } else {
      // 非表示にして、header要素のIDを削除
      brandHeaderDiv.style.display = 'none';

      const headerElement = brandHeaderDiv.querySelector('header');
      if (headerElement && headerElement.id === 'header') {
        headerElement.removeAttribute('id');
      }
    }
  });

  // brand-headerがない場合は通常のヘッダーを表示
  if (allBrandHeaders.length === 0) {
    const normalHeader = document.getElementById('shopify-section-header');
    if (normalHeader) {
      normalHeader.style.display = 'block';
    } else {
    }
  }
}

/**
 * StoreCRM お気に入り一覧ページ カスタマイズ
 */

// グローバル変数
let customizationAttempts = 0;
const MAX_ATTEMPTS = 10;

// お気に入りページでのみ実行
if (window.location.pathname.includes('/pages/favorite') ||
    window.location.pathname.includes('/apps/obake/favorites')) {
  // console.log('✅ お気に入りページを検出:', window.location.pathname);

  document.addEventListener('DOMContentLoaded', function() {
    initWishlistCustomization();
  });

  window.addEventListener('load', function() {
    setTimeout(function() {
      customizeWishlistCartButtons();
    }, 300);
  });
}

// 初期化関数
function initWishlistCustomization() {
  // console.log('🔄 お気に入りページ初期化開始');

  // コンテンツが存在するか確認
  function waitForContent(retryCount) {
    retryCount = retryCount || 0;
    const maxRetries = 20; // 10→20に増加（6秒）

    const mainContent = document.querySelector('#MainContent');
    const hasContent = document.querySelector('.storecrm_favoritelist, [class*="obake"]');

    // console.log('📦 コンテンツ確認（試行', retryCount + 1, '）:', {
    //   mainContent: mainContent ? '存在' : '未存在',
    //   hasContent: hasContent ? '存在' : '未存在'
    // });

    if (!mainContent || !hasContent) {
      if (retryCount < maxRetries) {
        setTimeout(function() {
          waitForContent(retryCount + 1);
        }, 300);
        return;
      } else {
        console.error('❌ お気に入りコンテンツが見つかりませんでした（', maxRetries, '回試行）');
        console.warn('🔄 ページをリロードします...');

        // sessionStorageにリロード試行回数を記録（無限ループ防止）
        var reloadAttempts = parseInt(sessionStorage.getItem('favoriteContentReloadAttempts') || '0');
        if (reloadAttempts < 2) {
          sessionStorage.setItem('favoriteContentReloadAttempts', (reloadAttempts + 1).toString());
          setTimeout(function() {
            window.location.reload();
          }, 1000);
        } else {
          console.error('❌ 最大リロード回数に達しました - 手動でページを更新してください');
          sessionStorage.removeItem('favoriteContentReloadAttempts');
        }
        return;
      }
    }

    // console.log('✅ コンテンツ確認完了 - カスタマイズ開始');

    // リロードカウンターをリセット
    sessionStorage.removeItem('favoriteContentReloadAttempts');

    // 即座に実行
    customizeWishlistCartButtons();

    // リトライ実行
    const intervals = [300, 800, 1500];
    intervals.forEach(function(delay) {
      setTimeout(function() {
        customizeWishlistCartButtons();
      }, delay);
    });

    // MutationObserverをセットアップ
    setupObserver();
  }

  // コンテンツ待機開始
  waitForContent();
}

function customizeWishlistCartButtons() {
  // すべてのお気に入りアイテムを取得
  const wishlistItems = document.querySelectorAll('tr[class*="storecrm_favoritelist_id-"]');

  if (wishlistItems.length === 0) {
    customizationAttempts++;
    // console.log('⚠️ [お気に入り] アイテムが見つかりません（試行回数:', customizationAttempts, '）');
    return;
  }

  // 未処理のアイテムをカウント
  const unprocessedItems = Array.from(wishlistItems).filter(function(item) {
    return !item.hasAttribute('data-customized');
  });

  // すべて処理済みの場合はスキップ
  if (unprocessedItems.length === 0) {
    return; // ログを出さずにスキップ
  }

  // console.log('🔄 [お気に入り] カスタマイズ実行:', unprocessedItems.length + '個の新しいアイテム');
  let processedCount = 0;

  wishlistItems.forEach(function(item, itemIndex) {
    // 既に処理済みかチェック
    if (item.hasAttribute('data-customized')) {
      return;
    }

    // カート追加ボタンのコンテナ
    const linksContainer = item.querySelector('.storecrm_favoritelist_links');
    if (!linksContainer) {
      return;
    }

    // 右側のtdを取得
    const rightTd = item.querySelector('.storecrm_favoritelist_righttd');

    // すべてのリンクを取得
    const links = linksContainer.querySelectorAll('.storecrm_favoritelist_link');

    if (links.length === 0) {
      return;
    }

    let hasCartButton = false;

    // 各リンクを確認して、カートアイコンがあるものを特定
    links.forEach(function(link, linkIndex) {
      // 既に処理済みの場合はスキップ
      if (link.classList.contains('custom-cart-button') || link.classList.contains('custom-out-of-stock-button')) {
        hasCartButton = true;
        return;
      }

      // SVGの内容でカートボタンかどうかを判別
      const svg = link.querySelector('svg');

      if (svg) {
        const path = svg.querySelector('path');
        const dAttr = path ? path.getAttribute('d') : '';

        // 削除ボタン（×アイコン）のパス
        const isDeleteButton = dAttr && dAttr.includes('M6 18L18 6M6 6l12 12');

        // 削除ボタンでない場合はカートボタンとして処理
        if (dAttr && !isDeleteButton) {
          hasCartButton = true;
          svg.remove();
          link.textContent = 'カートに追加';
          link.classList.add('custom-cart-button');
          processedCount++;
        }
      }
    });

    // カートボタンがない場合（在庫切れ）
    if (!hasCartButton && links.length === 1) {
      // 削除ボタンしかない = 在庫切れ

      // 在庫なしボタンを作成
      const outOfStockButton = document.createElement('div');
      outOfStockButton.className = 'custom-out-of-stock-button';
      outOfStockButton.textContent = '在庫がありません';

      // 削除ボタンの前に挿入
      linksContainer.insertBefore(outOfStockButton, linksContainer.firstChild);

      processedCount++;
    }

    // 画像に商品詳細へのリンクを追加
    addImageLink(item);

    // 商品価格を取得して表示
    addProductPrice(item);

    // 処理済みマーク
    item.setAttribute('data-customized', 'true');
  });

  // console.log('✅ [お気に入り] カスタマイズ完了 - 処理数:', processedCount);
}

// 商品価格を取得して表示する関数
function addProductPrice(item) {
  const leftTd = item.querySelector('.storecrm_favoritelist_lefttd');
  if (!leftTd) return;

  // 既に価格が表示されているかチェック
  if (leftTd.querySelector('.product-price')) {
    return;
  }

  // 商品リンクを取得
  const productLink = leftTd.querySelector('a:not(.product-image-link)');
  if (!productLink || !productLink.href) {
    return;
  }

  // 商品リンクにクラスを追加（2行制限用）
  productLink.classList.add('product-name-link');

  // URLから商品ハンドルを抽出
  const url = new URL(productLink.href);
  const pathParts = url.pathname.split('/');
  const productsIndex = pathParts.indexOf('products');

  if (productsIndex === -1 || !pathParts[productsIndex + 1]) {
    return;
  }

  const productHandle = pathParts[productsIndex + 1];

  // バリアントIDを取得（URLパラメータから）
  const variantId = url.searchParams.get('variant');

  // 価格表示要素を作成（ローディング状態）
  const priceElement = document.createElement('span');
  priceElement.className = 'product-price loading';
  priceElement.textContent = '価格を読み込み中...';
  leftTd.appendChild(priceElement);

  // Shopify Product JSON APIで商品データを取得
  fetch('/products/' + productHandle + '.js')
    .then(function(response) {
      if (!response.ok) {
        throw new Error('商品データの取得に失敗しました');
      }
      return response.json();
    })
    .then(function(product) {
      let price = product.price; // デフォルト価格

      // バリアントIDが指定されている場合、そのバリアントの価格を取得
      if (variantId && product.variants) {
        const variant = product.variants.find(function(v) {
          return v.id === parseInt(variantId);
        });
        if (variant) {
          price = variant.price;
        }
      }

      // 価格を円表記に変換
      // Shopifyは銭単位（セント単位）で保存しているため100で割る
      const priceInYen = Math.floor(price / 100);
      const formattedPrice = '¥' + priceInYen.toLocaleString('ja-JP') + '（税込）';

      // 価格を表示
      priceElement.textContent = formattedPrice;
      priceElement.classList.remove('loading');

    })
    .catch(function(error) {
      priceElement.textContent = '価格情報なし';
      priceElement.classList.remove('loading');
    });
}

// 画像に商品詳細へのリンクを追加する関数
function addImageLink(item) {
  // 左側のtd（画像と商品名が入っている）
  const leftTd = item.querySelector('.storecrm_favoritelist_lefttd');
  if (!leftTd) return;

  // 商品画像を取得
  const img = leftTd.querySelector('.storecrm_favoritelist_img');
  if (!img) return;

  // 既にリンクでラップされているかチェック
  if (img.parentElement.tagName === 'A' && img.parentElement.classList.contains('product-image-link')) {
    return;
  }

  // 商品名のリンクを取得（URLを取得するため）
  const productLink = leftTd.querySelector('a');
  if (!productLink || !productLink.href) {
    return;
  }

  const productUrl = productLink.href;

  // 画像をaタグでラップ
  const imageLink = document.createElement('a');
  imageLink.href = productUrl;
  imageLink.className = 'product-image-link';
  imageLink.style.display = 'block';
  imageLink.style.cursor = 'pointer';

  // 画像の親要素から画像を取り出し、リンクでラップする
  const imgParent = img.parentElement;
  imgParent.insertBefore(imageLink, img);
  imageLink.appendChild(img);


  // 商品名のリンクにもホバー効果を追加
  if (productLink) {
    productLink.style.transition = 'color 0.3s ease';
    productLink.addEventListener('mouseenter', function() {
      this.style.color = '#666';
    });
    productLink.addEventListener('mouseleave', function() {
      this.style.color = '#404040';
    });
  }
}

// MutationObserverのセットアップ
function setupObserver() {
  let debounceTimer = null;

  const observer = new MutationObserver(function(mutations) {
    let shouldUpdate = false;

    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        // 新しいノードが追加されたかチェック
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && ( // Element node
            node.classList && node.classList.contains('storecrm_favoritelist_link') ||
            node.querySelector && node.querySelector('.storecrm_favoritelist_link')
          )) {
            shouldUpdate = true;
          }
        });
      }
    });

    if (shouldUpdate) {
      // デバウンス: 既存のタイマーをクリアして新しいタイマーをセット
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }

      debounceTimer = setTimeout(function() {
        customizeWishlistCartButtons();
        debounceTimer = null;
      }, 300);
    }
  });

  // お気に入りリストの親要素を監視
  function startObserving() {
    const wishlistContainer = document.querySelector('.storecrm_favoritelist');
    if (wishlistContainer) {
      observer.observe(wishlistContainer, {
        childList: true,
        subtree: true
        // attributes: true を削除（属性変更では監視しない）
      });
      // console.log('👀 [お気に入り] MutationObserver開始');
      return true;
    }
    return false;
  }

  // リトライ付きで監視開始
  if (!startObserving()) {
    setTimeout(startObserving, 500);
    setTimeout(startObserving, 1000);
    setTimeout(startObserving, 2000);
  }
}

/**
 * Staff Start 絞り込みモーダルの初期化（新アプローチ：絞り込むボタン追加）
 */
function initStaffStartFilterModal() {

  // 既に初期化済みかチェック
  if (window.staffStartModalInitialized) {
    return true;
  }

  // 絞り込みボタンとコンテンツを取得（2個目のクラス名は可変なので最初のクラスのみ）
  const filterButton = document.querySelector('#staffstart-shopify-app-container .sc-hHOBiw');

  // sc-kWtpeLクラスを持つ要素を探す（2番目のクラス名は問わない）
  let filterContent = document.querySelector('#staffstart-shopify-app-container .sc-kWtpeL');

  // body直下に既に移動されている場合も考慮
  if (!filterContent) {
    filterContent = document.querySelector('.sc-kWtpeL');
  }

  if (!filterButton || !filterContent) {
    return false;
  }



  // モーダルコンテンツをbody直下に移動（親要素のz-index制限を回避）
  if (filterContent.parentElement && filterContent.parentElement.tagName.toLowerCase() !== 'body') {
    // 元の位置を記憶（必要に応じて）
    filterContent.setAttribute('data-moved-to-body', 'true');
    document.body.appendChild(filterContent);
  }

  // オーバーレイを作成
  let overlay = document.querySelector('.staffstart-modal-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'staffstart-modal-overlay';
    document.body.appendChild(overlay);
  }

  // 閉じるボタンを作成
  let closeButton = filterContent.querySelector('.staffstart-modal-close');
  if (!closeButton) {
    closeButton = document.createElement('button');
    closeButton.className = 'staffstart-modal-close';
    closeButton.setAttribute('aria-label', '閉じる');
    filterContent.insertBefore(closeButton, filterContent.firstChild);
  }

  // 絞り込むボタンを作成
  let filterSubmitButton = filterContent.querySelector('.staffstart-filter-submit');
  if (!filterSubmitButton) {
    filterSubmitButton = document.createElement('button');
    filterSubmitButton.className = 'staffstart-filter-submit';
    filterSubmitButton.textContent = '絞り込む';
    filterContent.appendChild(filterSubmitButton);

    // 絞り込むボタンのクリックイベント
    filterSubmitButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      // 現在のURLパラメーターを取得
      const urlParams = new URLSearchParams(window.location.search);
      const currentLabel = urlParams.get('label');
      const currentGenre = urlParams.get('genre') || '2';

      // セレクトボックスの値を取得（より確実な方法）
      const allSelects = filterContent.querySelectorAll('select');

      let selectedCategory = null;
      let selectedShop = null;

      // 各セクションからselectを取得
      const sections = filterContent.querySelectorAll('.sc-EgOXT');
      sections.forEach(function(section, index) {
        const select = section.querySelector('select');
        if (select && select.value && select.value !== '') {
          // セクションのタイトルから判定
          const titleElement = section.querySelector('.sc-gEvEer');
          const title = titleElement ? titleElement.textContent : '';


          if (title.includes('カテゴリ')) {
            selectedCategory = select.value;
          } else if (title.includes('店舗')) {
            selectedShop = select.value;
          }
        }
      });


      // 新しいURLを構築
      let newUrl = '/apps/staffstart/coordinates/';
      let params = [];

      // genreとlabelは常に含める
      if (currentGenre) params.push('genre=' + currentGenre);
      if (currentLabel) params.push('label=' + currentLabel);

      // カテゴリが選択されている場合
      if (selectedCategory) {
        params.push('productParentCategory=' + encodeURIComponent(selectedCategory));
      }

      // 店舗が選択されている場合
      if (selectedShop) {
        params.push('shopId=' + selectedShop);
      }

      if (params.length > 0) {
        newUrl += '?' + params.join('&');
      }


      // ページ遷移
      window.location.href = newUrl;
    });
  }

  // モーダルを開く関数
  function openModal() {
    filterContent.classList.add('is-open');
    overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  // モーダルを閉じる関数
  function closeModal() {
    filterContent.classList.remove('is-open');
    overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  // イベント委譲を使用して確実にクリックを捕捉（重複登録を防ぐ）
  if (!document.body.hasAttribute('data-staffstart-modal-listener')) {
    document.body.setAttribute('data-staffstart-modal-listener', 'true');

    document.body.addEventListener('click', function(e) {
      // 絞り込みボタンがクリックされたかチェック（2個目のクラス名は可変）
      const clickedButton = e.target.closest('.sc-hHOBiw');
      if (clickedButton && document.querySelector('.staffstart-modal-overlay')) {
        e.preventDefault();
        e.stopPropagation();

        // モーダルを開く（2個目のクラス名は可変）
        const modalContent = document.querySelector('.sc-kWtpeL');
        const modalOverlay = document.querySelector('.staffstart-modal-overlay');

        if (modalContent && modalOverlay) {
          modalContent.classList.add('is-open');
          modalOverlay.classList.add('is-active');
          document.body.style.overflow = 'hidden';
        }
        return;
      }

      // 閉じるボタンがクリックされたかチェック
      const clickedClose = e.target.closest('.staffstart-modal-close');
      if (clickedClose) {
        e.preventDefault();
        e.stopPropagation();

        // モーダルを閉じる（2個目のクラス名は可変）
        const modalContent = document.querySelector('.sc-kWtpeL');
        const modalOverlay = document.querySelector('.staffstart-modal-overlay');

        if (modalContent && modalOverlay) {
          modalContent.classList.remove('is-open');
          modalOverlay.classList.remove('is-active');
          document.body.style.overflow = '';
        }
        return;
      }
    }, true); // キャプチャフェーズで実行

  }

  // オーバーレイのクリックイベント
  overlay.addEventListener('click', function(e) {
    closeModal();
  });

  // 新着順/人気順のアクティブ状態を設定
  function updateSortButtonsState() {
    const sortContainer = document.querySelector('#staffstart-shopify-app-container .sc-lnPyaJ');
    if (!sortContainer) return;

    const sortButtons = sortContainer.querySelectorAll('.sc-eulNck');
    const currentUrl = window.location.href;
    const hasSortParam = currentUrl.includes('sort=');

    sortButtons.forEach(function(button) {
      const href = button.getAttribute('href');
      const isPopularButton = href && href.includes('sort=pv');
      const isNewButton = href && !href.includes('sort=');

      // 現在のURLに基づいてアクティブ状態を判定
      if (hasSortParam && currentUrl.includes('sort=pv') && isPopularButton) {
        // 人気順がアクティブ
        button.style.color = '#404040';
        button.style.fontWeight = '600';
        button.style.borderBottomColor = '#404040';
      } else if (!hasSortParam && isNewButton) {
        // 新着順がアクティブ（デフォルト）
        button.style.color = '#404040';
        button.style.fontWeight = '600';
        button.style.borderBottomColor = '#404040';
      } else {
        // 非アクティブ
        button.style.color = '#999';
        button.style.fontWeight = '400';
        button.style.borderBottomColor = 'transparent';
      }
    });

  }

  // 初期化時とページ読み込み時に実行
  setTimeout(updateSortButtonsState, 500);
  setTimeout(updateSortButtonsState, 1000);

  // 初期化完了フラグ
  window.staffStartModalInitialized = true;

  return true;
}

// Staff Start絞り込みモーダルの自動初期化（Staff Startページでのみ実行）
if (window.location.pathname.includes('/apps/staffstart/')) {
  (function() {

    /*当該ページにおける見出しDOM生成処理-開始*/
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const targetBdLabel = urlParams.get('label');
    let bdLabel = "";
    let brandFontClass = "";

    if (targetBdLabel == "ANEMONE") {
      bdLabel = " pattern2";
      brandFontClass = "anemone-font";
    } else if (targetBdLabel == "SIENA ROSE") {
      bdLabel = " pattern3";
      brandFontClass = "siena-font";
    } else if (targetBdLabel == "too:") {
      bdLabel = " pattern4";
      brandFontClass = "too-font";
    } else if (targetBdLabel == "mimi33") {
      bdLabel = " pattern5";
      brandFontClass = "mimi33-font";
    } else if (targetBdLabel == "MR.mimi33") {
      bdLabel = " pattern6";
      brandFontClass = "mrmimi-font";
    } else if (targetBdLabel == "itsti") {
      bdLabel = " pattern7";
      brandFontClass = "itsti-font";
    } else {
      bdLabel = " pattern1";
      brandFontClass = "";
    }
    const staffSnapStyle = document.createElement('style');
    staffSnapStyle.textContent = `
      #staffstart-shopify-app-container .staff_snap-title {
          font-size:40px;
          font-weight:400;
          font-family:"Noto Sans", sans-serif;
          text-align:center;
          line-height:1.4;
          margin-top:20px;
          margin-bottom:30px;
      }
      #staffstart-shopify-app-container .staff_snap-title.pattern2,
      #staffstart-shopify-app-container .staff_snap-title.pattern2 > * {
          font-size:30px;
          font-family:"freight-neo-pro", sans-serif;
      }
      #staffstart-shopify-app-container .staff_snap-title.pattern3,
      #staffstart-shopify-app-container .staff_snap-title.pattern3 > * {
          font-size:30px;
          font-family:"sorts-mill-goudy", serif;
          color: #646363;
      }
      #staffstart-shopify-app-container .staff_snap-title.pattern4,
      #staffstart-shopify-app-container .staff_snap-title.pattern4 > * {
          font-size:30px;
          font-family:"futura-pt", sans-serif;
          font-weight:400;
          color: #5C5C5C;
      }
      #staffstart-shopify-app-container .staff_snap-title.pattern5,
      #staffstart-shopify-app-container .staff_snap-title.pattern5 > * {
          font-size:30px;
          font-family:"din-2014", sans-serif;
      }
      #staffstart-shopify-app-container .staff_snap-title.pattern6,
      #staffstart-shopify-app-container .staff_snap-title.pattern6 > * {
          font-size:30px;
          font-family:"din-2014", sans-serif;
          font-weight:600;
          color: #313131;
      }
      #staffstart-shopify-app-container .staff_snap-title.pattern7,
      #staffstart-shopify-app-container .staff_snap-title.pattern7 > * {
          font-size:30px;
          font-family:"collier", sans-serif;
      }
      @media (max-width: 750px) {
          #staffstart-shopify-app-container .staff_snap-title {
              font-size:30px;
          }
          #staffstart-shopify-app-container .staff_snap-title.pattern2,
          #staffstart-shopify-app-container .staff_snap-title.pattern2 > * {
              font-size:20px;
          }
          #staffstart-shopify-app-container .staff_snap-title.pattern3,
          #staffstart-shopify-app-container .staff_snap-title.pattern3 > * {
              font-size:20px;
          }
          #staffstart-shopify-app-container .staff_snap-title.pattern4,
          #staffstart-shopify-app-container .staff_snap-title.pattern4 > * {
              font-size:20px;
          }
          #staffstart-shopify-app-container .staff_snap-title.pattern5,
          #staffstart-shopify-app-container .staff_snap-title.pattern5 > * {
              font-size:20px;
          }
          #staffstart-shopify-app-container .staff_snap-title.pattern6,
          #staffstart-shopify-app-container .staff_snap-title.pattern6 > * {
              font-size:20px;
          }
          #staffstart-shopify-app-container .staff_snap-title.pattern7,
          #staffstart-shopify-app-container .staff_snap-title.pattern7 > * {
              font-size:20px;
          }
      }
    `;
    document.head.appendChild(staffSnapStyle);
    window.addEventListener('load', function() {
      const targetEle = document.querySelector('#staffstart-shopify-app-container .sc-bOQTJJ');
      targetEle.insertAdjacentHTML('afterend', '<h1 class="staff_snap-title'+bdLabel+'"><budoux-ja style="word-break: keep-all; overflow-wrap: anywhere;">Staff Snap</budoux-ja></h1>');
    });

    // sc-gmPhUn要素にブランドフォントクラスを追加
    if (brandFontClass) {
      const addBrandClassToTitle = function() {
        const titleElements = document.querySelectorAll('#staffstart-shopify-app-container .sc-gmPhUn');
        titleElements.forEach(function(el) {
          if (!el.classList.contains(brandFontClass)) {
            el.classList.add(brandFontClass);
            console.log('✅ ブランドクラスを追加:', brandFontClass, 'to', el);
          }
        });
      };

      // 初回実行
      setTimeout(addBrandClassToTitle, 500);

      // MutationObserverで動的に追加される要素も監視
      const observer = new MutationObserver(function(mutations) {
        addBrandClassToTitle();
      });

      // Staff Startコンテナを監視
      const staffStartContainer = document.querySelector('#staffstart-shopify-app-container');
      if (staffStartContainer) {
        observer.observe(staffStartContainer, {
          childList: true,
          subtree: true
        });
      }

      // 定期的にもチェック（念のため）
      const intervalId = setInterval(addBrandClassToTitle, 1000);

      // 10秒後に定期チェックを停止
      setTimeout(function() {
        clearInterval(intervalId);
      }, 10000);
    }
    /*当該ページにおける見出しDOM生成処理-修了*/

    let checkCount = 0;
    const maxChecks = 25; // チェック回数を削減（50→25）

    function tryInitialize() {
      checkCount++;

      if (window.staffStartModalInitialized) {
        return true;
      }

      // 2個目のクラス名は可変なので最初のクラスのみで検索
      const filterButton = document.querySelector('#staffstart-shopify-app-container .sc-hHOBiw');
      const filterContent = document.querySelector('#staffstart-shopify-app-container .sc-kWtpeL');

      if (filterButton && filterContent) {
        if (initStaffStartFilterModal()) {
          return true;
        }
      }

      return false;
    }

    // ページ読み込み完了後に開始
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        startChecking();
      });
    } else {
      startChecking();
    }

    function startChecking() {
      // 即座に1回試行
      if (!tryInitialize()) {
        // 間隔を長くして負荷を減らす（200ms→400ms）
        const checkInterval = setInterval(function() {
          if (tryInitialize() || checkCount >= maxChecks) {
            clearInterval(checkInterval);
          }
        }, 400);
      }
    }
  })();
}

// ========================================
// スタッフスタート：ブランド別店舗絞り込み
// ========================================
(function() {
  // console.log('🏪 Staff Start店舗絞り込み機能を初期化');
  // console.log('📍 現在のURL:', window.location.pathname);

  // window.shopMasterDataの存在確認
  if (typeof window.shopMasterData !== 'undefined' && window.shopMasterData && window.shopMasterData.length > 0) {
    // console.log('✅ shopMasterData読み込み済み:', window.shopMasterData.length, '件（最大50件）');
  } else {
    console.log('⚠️ shopMasterDataが見つかりません');
  }

  // 旧実装: Storefront API処理は不要（50件制限で十分）
  // メタオブジェクト取得関数（削除済み）
  function fetchShopMasterData_DISABLED() {
    return new Promise((resolve, reject) => {
      console.log('📋 メタオブジェクト取得開始 (custom.js)...');

      // すでにAPI経由で読み込み済みの場合はスキップ
      if (window.shopMasterDataLoaded === 'api_complete' && window.shopMasterData && window.shopMasterData.length > 0) {
        console.log('✅ メタオブジェクトは既にAPI経由で読み込み済み:', window.shopMasterData.length, '件');
        resolve(window.shopMasterData);
        return;
      }

      console.log('🔄 Storefront APIで全件取得を開始します...');

      // ブランドに応じたメタオブジェクトタイプを取得
      const metaobjectTypes = getMetaobjectTypes();
      console.log('📦 取得対象メタオブジェクトタイプ:', metaobjectTypes);

      // 単一のGraphQLクエリで複数のメタオブジェクトタイプを取得
      const queryFragments = metaobjectTypes.map((type, index) => {
        return `
          type${index}: metaobjects(type: "${type}", first: 250) {
            edges {
              node {
                fields {
                  key
                  value
                }
              }
            }
          }
        `;
      }).join('\n');

      const query = `
        query GetShopMaster {
          ${queryFragments}
        }
      `;

      // Storefront Access Tokenを抽出（複数の方法を試行）
      let storefrontToken = '';

      // 方法1: content_for_headerのscriptタグから抽出
      const scripts = document.querySelectorAll('script');
      scripts.forEach(script => {
        const content = script.textContent || '';
        if (content.includes('storefrontAccessToken')) {
          const match = content.match(/"storefrontAccessToken"\s*:\s*"([^"]+)"/);
          if (match) {
            storefrontToken = match[1];
            console.log('✅ Token取得成功（方法1: script tag）');
          }
        }
      });

      // 方法2: meta tagから抽出
      if (!storefrontToken) {
        const metaToken = document.querySelector('meta[name="shopify-storefront-api-token"]');
        if (metaToken) {
          storefrontToken = metaToken.getAttribute('content');
          console.log('✅ Token取得成功（方法2: meta tag）');
        }
      }

      // 方法3: window.Shopifyオブジェクトから抽出（念のため）
      if (!storefrontToken && window.Shopify && window.Shopify.storefrontAccessToken) {
        storefrontToken = window.Shopify.storefrontAccessToken;
        console.log('✅ Token取得成功（方法3: window.Shopify）');
      }

      // 方法4: HTML全体から正規表現で検索
      if (!storefrontToken) {
        const htmlContent = document.documentElement.innerHTML;
        const match = htmlContent.match(/"storefrontAccessToken"\s*:\s*"([^"]+)"/);
        if (match) {
          storefrontToken = match[1];
          console.log('✅ Token取得成功（方法4: HTML全体検索）');
        }
      }

      if (!storefrontToken) {
        console.warn('⚠️ Storefront Access Token が見つかりません（全ての方法で失敗）');
        console.log('💡 フォールバック: JSON APIからデータを取得します');

        // JSON APIからデータを取得（Staff Startページ用のフォールバック）
        fetch('/pages/shopmaster-api')
          .then(response => {
            if (!response.ok) {
              throw new Error('JSON API request failed: ' + response.status);
            }
            return response.json();
          })
          .then(data => {
            if (data && data.shops && Array.isArray(data.shops)) {
              window.shopMasterData = data.shops;
              window.shopMasterDataLoaded = 'api_complete';
              console.log('✅ JSON APIからメタオブジェクト取得完了:', data.shops.length, '件');

              // ブランド別の件数を表示
              const brandCounts = {};
              data.shops.forEach(shop => {
                if (shop.shopname) {
                  const brand = shop.shopname.split(' ')[0];
                  brandCounts[brand] = (brandCounts[brand] || 0) + 1;
                }
              });
              console.log('📊 ブランド別件数:', brandCounts);

              resolve(data.shops);
            } else {
              throw new Error('Invalid JSON API response format');
            }
          })
          .catch(error => {
            console.error('⚠️ JSON API取得エラー:', error);
            console.log('💡 最終フォールバック: 空データで解決');
            window.shopMasterDataLoaded = 'api_failed';
            resolve(window.shopMasterData || []);
          });
        return;
      }

      console.log('🔑 Token取得成功 - 長さ:', storefrontToken.length, '文字');

      fetch(window.Shopify.routes.root + 'api/2024-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontToken
        },
        body: JSON.stringify({ query: query })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('API request failed: ' + response.status);
        }
        return response.json();
      })
      .then(data => {
        if (data.errors) {
          console.error('⚠️ GraphQL エラー:', data.errors);
          throw new Error('GraphQL errors: ' + JSON.stringify(data.errors));
        }

        if (data.data) {
          const allShops = [];

          // 複数のメタオブジェクトタイプから取得したデータを結合
          Object.keys(data.data).forEach(key => {
            if (key.startsWith('type') && data.data[key] && data.data[key].edges) {
              console.log(`📦 ${key} から ${data.data[key].edges.length} 件取得`);

              data.data[key].edges.forEach(edge => {
                const fields = edge.node.fields;
                const shop = {};
                fields.forEach(field => {
                  shop[field.key] = field.value;
                });
                allShops.push(shop);
              });
            }
          });

          if (allShops.length === 0) {
            throw new Error('No shops found in metaobjects');
          }

          window.shopMasterData = allShops;
          window.shopMasterDataLoaded = 'api_complete';
          console.log('✅ メタオブジェクト全件取得完了 (custom.js):', allShops.length, '件');

          // ブランド別の件数を表示
          const brandCounts = {};
          allShops.forEach(shop => {
            if (shop.shopname) {
              const brand = shop.shopname.split(' ')[0];
              brandCounts[brand] = (brandCounts[brand] || 0) + 1;
            }
          });
          console.log('📊 ブランド別件数:', brandCounts);

          resolve(allShops);
        } else {
          throw new Error('No data received from API');
        }
      })
      .catch(error => {
        console.error('⚠️ メタオブジェクト取得エラー (custom.js):', error);
        reject(error);
      });
    });
  }

  // URLからブランドを判定（パスまたはlabelパラメータ）
  function getBrandFromURL() {
    const path = window.location.pathname.toLowerCase();
    const urlParams = new URLSearchParams(window.location.search);
    const labelParam = urlParams.get('label');

    console.log('🔍 パス確認:', path);
    console.log('🔍 labelパラメータ:', labelParam);

    const brandMap = {
      'anemone': ['ANEMONE', 'ANEMONE HAIR'],
      'itsti': ['iT\'ｓTi', 'iT\'sTi', 'itsti'],
      'mimi33': ['mimi33', 'MR.mimi33'],
      'mr': ['MR.mimi33', 'mimi33'],
      'siena': ['SIENA', 'SIENA ROSE'],
      'too': ['too:']
    };

    // 1. labelパラメータから判定（スタッフスタート用）
    if (labelParam) {
      const labelLower = labelParam.toLowerCase();
      for (const [key, brands] of Object.entries(brandMap)) {
        if (labelLower.includes(key)) {
          console.log('✅ ブランド判定（labelパラメータ）:', key, '→', brands);
          return brands;
        }
      }
    }

    // 2. パスから判定（通常のページ用）
    for (const [key, brands] of Object.entries(brandMap)) {
      if (path.includes('/' + key)) {
        console.log('✅ ブランド判定（パス）:', key, '→', brands);
        return brands;
      }
    }

    console.log('ℹ️ ブランド判定なし（全店舗表示）');
    return null;
  }

  // スタッフスタートのモーダルを監視し、店舗セレクトボックスをフィルタリング
  function filterStoreSelect(retryCount) {
    retryCount = retryCount || 0;
    // console.log('🔄 filterStoreSelect() 実行開始（試行回数:', retryCount + 1, '）');

    // データ取得が未完了の場合、取得を試みる
    if (window.shopMasterDataLoaded === false ||
        (typeof window.shopMasterData === 'undefined') ||
        (window.shopMasterData && window.shopMasterData.length === 0)) {

      console.log('⚠️ shopMasterDataが存在しません → フィルタリングをスキップ');
      return;
    }

    // console.log('✅ shopMasterData件数:', window.shopMasterData.length);

    // ブランドを判定
    const brandNames = getBrandFromURL();
    if (!brandNames) {
      // ブランドページではない場合は何もしない
      // console.log('⚠️ ブランド判定なしのため処理終了');
      return;
    }
    // console.log('✅ 判定ブランド:', brandNames);

    // スタッフスタートページまたはモーダルが存在するかチェック
    const isStaffStartPage = window.location.pathname.includes('/apps/staffstart/');
    const modalExists = document.querySelector('.sc-kWtpeL') !== null;

    // ブランドページで、スタッフスタートページでもモーダルも存在しない場合は処理終了
    if (!isStaffStartPage && !modalExists && retryCount === 0) {
      console.log('ℹ️ ブランドページですが、スタッフスタートモーダルが存在しないため処理終了');
      return;
    }

    // スタッフスタートのモーダル内の店舗セレクトボックスを探す
    const storeSelects = document.querySelectorAll('.sc-EgOXT select.sc-gdyeKB');
    // console.log('📦 セレクトボックス検出数:', storeSelects.length);

    // セレクトボックスが見つからない場合の処理
    if (storeSelects.length === 0) {
      // スタッフスタートページまたはモーダルが存在する場合のみリトライ
      if ((isStaffStartPage || modalExists) && retryCount < 5) {
        // console.log('⏳ セレクトボックスが見つかりません。500ms後にリトライします...');
        setTimeout(function() {
          filterStoreSelect(retryCount + 1);
        }, 500);
        return;
      }

      // console.log('❌ セレクトボックスが見つかりませんでした');
      return;
    }

    storeSelects.forEach(function(select, index) {
      // console.log('🔍 セレクトボックス', index, 'を確認中');

      // 親コンテナとタイトルを取得
      const parentContainer = select.closest('.sc-EgOXT');
      if (!parentContainer) {
        // console.log('  ⚠️ 親コンテナが見つかりません');
        return;
      }

      const titleElement = parentContainer.querySelector('.sc-gEvEer');
      const titleText = titleElement ? titleElement.textContent.trim() : '';
      // console.log('  📝 タイトル要素:', titleText);

      // 「カテゴリから探す」の処理
      if (titleText === 'カテゴリから探す') {
        // console.log('✅ カテゴリセレクトボックスを検出:', select);

        // ブランドごとの表示カテゴリを定義
        const brandCategories = {
          'ANEMONE': [
            'ヘアアクセサリー',
            'リング',
            'ネックレス',
            'ピアス',
            'イヤリング',
            'イヤーカフ',
            'ブレスレット / バングル',
            'バッグ',
            'その他'
          ],
          'SIENA': [
            'ネックレス',
            'リング',
            'ピアス',
            'イヤリング',
            'イヤーカフ',
            'ブレスレット',
            'ペアジュエリー',
            'その他'
          ],
          'mimi33': [
            'ピアス',
            'イヤリング',
            'イヤーカフ',
            'リング',
            'ネックレス',
            'その他'
          ],
          'MR.mimi33': [
            'ピアス',
            'イヤリング',
            'イヤーカフ',
            'リング',
            'ネックレス',
            'その他'
          ]
        };

        // 現在のブランドを判定
        let currentBrandKey = null;
        if (brandNames) {
          if (brandNames.some(function(b) { return b.indexOf('ANEMONE') !== -1; })) {
            currentBrandKey = 'ANEMONE';
          } else if (brandNames.some(function(b) { return b.indexOf('SIENA') !== -1; })) {
            currentBrandKey = 'SIENA';
          } else if (brandNames.some(function(b) { return b.indexOf('MR.mimi33') !== -1; })) {
            currentBrandKey = 'MR.mimi33';
          } else if (brandNames.some(function(b) { return b.indexOf('mimi33') !== -1; })) {
            currentBrandKey = 'mimi33';
          }
        }

        // console.log('  🔍 ブランド判定:', currentBrandKey);

        // カテゴリがない場合は全て表示
        if (!currentBrandKey || !brandCategories[currentBrandKey]) {
          // console.log('  ⚠️ ブランド未判定のため全カテゴリ表示');
          return;
        }

        const allowedCategories = brandCategories[currentBrandKey];
        // console.log('  📋 許可カテゴリ:', allowedCategories);

        // オプションをフィルタリング
        const categoryOptions = select.querySelectorAll('option');
        let visibleCategoryCount = 0;

        categoryOptions.forEach(function(option) {
          const optionText = option.textContent.trim();

          // 「選択してください」は常に表示
          if (option.value === '' || optionText === '選択してください' || optionText === '') {
            option.style.display = '';
            return;
          }

          // 許可リストに含まれているかチェック
          const isAllowed = allowedCategories.some(function(category) {
            return optionText === category;
          });

          if (isAllowed) {
            option.style.display = '';
            visibleCategoryCount++;
            // console.log('  ✅ 表示:', optionText);
          } else {
            option.style.display = 'none';
            // console.log('  🚫 非表示:', optionText);
          }
        });

        // console.log('  📊 表示カテゴリ数:', visibleCategoryCount);

        return; // カテゴリ処理完了
      }

      // 「店舗から探す」以外はスキップ
      if (titleText !== '店舗から探す') {
        // console.log('  ⏭️ 店舗セレクトボックスではないのでスキップ');
        return;
      }

      // console.log('✅ 店舗セレクトボックスを検出:', select);

      // 元のオプションを保存（初回のみ）
      if (!select.dataset.originalOptions) {
        const originalOptionsHTML = select.innerHTML;
        select.dataset.originalOptions = originalOptionsHTML;
        console.log('💾 元のオプションを保存しました');
      }

      // フィルタリング対象の店舗名リストを作成
      const targetStoreNames = [];
      console.log('📋 メタオブジェクトから店舗名を抽出中...');

      // ブランド名を長い順にソート（"SIENA ROSE" を "SIENA" より先にチェック）
      const sortedBrandNames = brandNames.slice().sort(function(a, b) {
        return b.length - a.length;
      });
      console.log('🔤 ブランド名（長い順）:', sortedBrandNames);

      window.shopMasterData.forEach(function(shop) {
        const shopname = shop.shopname;

        // ブランド名が含まれているかチェック
        for (let i = 0; i < sortedBrandNames.length; i++) {
          const brandName = sortedBrandNames[i];

          if (shopname.indexOf(brandName) === 0) {
            // ブランド名を除いた店舗名を抽出
            // 例: "SIENA ROSE 表参道ヒルズ" → "表参道ヒルズ"
            const storeName = shopname.replace(brandName, '').trim();

            if (storeName) {
              targetStoreNames.push(storeName);
              // console.log('  ✅ マッチ:', shopname, '→', storeName);
            }
            break;
          }
        }
      });

      // console.log('🎯 表示対象の店舗（合計', targetStoreNames.length, '件）:', targetStoreNames);

      // オプションをフィルタリング（重複削除機能付き）
      const options = select.querySelectorAll('option');
      let visibleCount = 0;
      const shownStoreNames = {}; // 既に表示した店舗名を記録

      options.forEach(function(option) {
        const optionText = option.textContent.trim();

        // 「選択してください」は常に表示
        if (option.value === '' || option.style.display === 'none') {
          return;
        }

        // 対象店舗に含まれているかチェック
        let shouldShow = false;
        for (let i = 0; i < targetStoreNames.length; i++) {
          if (optionText.indexOf(targetStoreNames[i]) !== -1) {
            shouldShow = true;
            break;
          }
        }

        // 重複チェック：同じ店舗名が既に表示されている場合は非表示
        if (shouldShow) {
          if (shownStoreNames[optionText]) {
            // 2個目以降は非表示
            option.style.display = 'none';
            // console.log('  🔁 重複削除:', optionText, '（value=' + option.value + '）');
          } else {
            // 1個目は表示
            option.style.display = '';
            shownStoreNames[optionText] = true;
            visibleCount++;
          }
        } else {
          option.style.display = 'none';
        }
      });

      // console.log('✅ フィルタリング完了:', visibleCount, '件の店舗を表示（重複削除済み）');
    });
  }

  // MutationObserverでモーダルの出現を監視
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        // スタッフスタートのモーダルが追加されたかチェック
        if (node.nodeType === 1 &&
            (node.classList && node.classList.contains('sc-kWtpeL') ||
             (node.querySelector && node.querySelector('.sc-kWtpeL')))) {
          console.log('🔍 スタッフスタートモーダルを検出');

          // モーダルが完全に描画されるまで少し待つ
          setTimeout(function() {
            filterStoreSelect();
          }, 100);
        }
      });
    });
  });

  // body要素を監視開始
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    // console.log('👀 モーダル監視を開始しました');
  }

  // ページ読み込み時の実行は、スタッフスタートページまたはモーダルが存在する場合のみ
  function checkAndExecuteFilterStoreSelect() {
    // スタッフスタートページかチェック
    const isStaffStartPage = window.location.pathname.includes('/apps/staffstart/');

    // モーダルが既に存在するかチェック
    const modalExists = document.querySelector('.sc-kWtpeL') !== null;

    if (isStaffStartPage || modalExists) {
      // console.log('✅ スタッフスタートページまたはモーダル存在 - filterStoreSelect実行');
      setTimeout(filterStoreSelect, 1000);
      setTimeout(filterStoreSelect, 2000); // 追加の遅延実行
    }
    // else {
    //   console.log('ℹ️ スタッフスタートページではありません - filterStoreSelect実行をスキップ');
    // }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndExecuteFilterStoreSelect);
  } else {
    checkAndExecuteFilterStoreSelect();
  }
})();

// ==========================================
// カートに追加ボタンの二重送信防止 & 在庫チェック（Android端末対策）
// ==========================================
(function() {
  // console.log('🛡️ [カート二重送信防止 & 在庫チェック] 初期化開始');

  let isSubmitting = false;
  let submittingForms = new WeakSet();

  // 在庫チェック関数（Promise版）
  function checkInventoryBeforeAdd(variantId, quantity, productTitle) {
    console.log('🔍 [在庫チェック] バリアントID:', variantId, '追加数量:', quantity);

    // バリアントIDが取得できない場合はチェックをスキップ
    if (!variantId) {
      console.log('⚠️ [在庫チェック] バリアントIDが不明のためスキップ');
      return Promise.resolve(true);
    }

    // 商品データを取得して在庫情報を確認
    return fetch('/products/' + window.location.pathname.split('/products/')[1].split('?')[0] + '.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(product) {
        // 該当バリアントを探す
        const variant = product.variants.find(function(v) {
          return v.id == variantId;
        });

        if (!variant) {
          console.log('⚠️ [在庫チェック] バリアント情報が見つからないためスキップ');
          return true;
        }

        console.log('📦 [在庫チェック] バリアント情報:', variant);
        console.log('📋 [在庫チェック] 在庫管理:', variant.inventory_management);
        console.log('📋 [在庫チェック] 在庫ポリシー:', variant.inventory_policy);
        console.log('📊 [在庫チェック] 在庫数:', variant.inventory_quantity);

        // 在庫管理が有効で、在庫切れ時の販売を許可しない場合のみチェック
        if (variant.inventory_management && variant.inventory_policy === 'deny') {
          // カート内の同じバリアントの数量を確認
          return fetch('/cart.js')
            .then(function(response) {
              return response.json();
            })
            .then(function(cart) {
              let currentCartQuantity = 0;
              cart.items.forEach(function(item) {
                if (item.variant_id == variantId) {
                  currentCartQuantity = item.quantity;
                }
              });

              const totalQuantity = currentCartQuantity + quantity;
              const inventoryQuantity = variant.inventory_quantity || 0;

              console.log('📊 [在庫チェック] カート内:', currentCartQuantity, '追加:', quantity, '合計:', totalQuantity, '在庫:', inventoryQuantity);

              if (totalQuantity > inventoryQuantity) {
                const title = productTitle || product.title || '商品';
                console.log('⚠️ [在庫チェック] 在庫不足検知');
                alert('申し訳ございません。\n「' + title + '」の在庫が不足しています。\n\n在庫数: ' + inventoryQuantity + '個\nカート内: ' + currentCartQuantity + '個\n追加希望: ' + quantity + '個\n合計: ' + totalQuantity + '個');
                return false;
              }

              return true;
            });
        }

        // 在庫管理が無効な場合は常に許可
        return true;
      })
      .catch(function(error) {
        console.error('❌ [在庫チェック] エラー:', error);
        // エラー時は追加を許可（安全策）
        return true;
      });
  }

  function preventDoubleSubmit() {
    // すべての「カートに追加」フォームを取得
    const addToCartForms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    // console.log('📋 [カート二重送信防止] フォーム数:', addToCartForms.length);

    addToCartForms.forEach(function(form, index) {
      // 既に処理済みのフォームはスキップ
      if (submittingForms.has(form)) {
        console.log('  ⏭️ [フォーム' + index + '] 既に処理済み');
        return;
      }

      console.log('  🔧 [フォーム' + index + '] 二重送信防止 & 在庫チェックを設定');

      // フォーム送信イベント
      form.addEventListener('submit', function(e) {
        // 既に送信中の場合は中止
        if (isSubmitting) {
          console.log('  ⚠️ [フォーム' + index + '] 二重送信を検知 - 中止します');
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }

        // フォームからバリアントIDと数量を取得
        const variantIdInput = form.querySelector('input[name="id"]');
        const quantityInput = form.querySelector('input[name="quantity"]');
        const variantId = variantIdInput ? variantIdInput.value : null;
        const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

        // 商品タイトルを取得（可能な場合）
        const productTitle = document.querySelector('.product-title, .product__title, h1[itemprop="name"]');
        const title = productTitle ? productTitle.textContent : null;

        console.log('  🔍 [フォーム' + index + '] 在庫チェック開始 - バリアントID:', variantId, '数量:', quantity);

        // 一旦フォーム送信を停止
        e.preventDefault();
        e.stopPropagation();

        // 在庫チェックを実行
        checkInventoryBeforeAdd(variantId, quantity, title).then(function(canAdd) {
          if (!canAdd) {
            console.log('  ❌ [フォーム' + index + '] 在庫チェックで送信中止');
            return;
          }

          console.log('  ✅ [フォーム' + index + '] 送信開始');
          isSubmitting = true;

          // ボタンを無効化
          const submitButton = form.querySelector('button[type="submit"]');
          if (submitButton) {
            submitButton.disabled = true;
            submitButton.style.pointerEvents = 'none';
            submitButton.style.opacity = '0.6';
            console.log('  🔒 [フォーム' + index + '] ボタン無効化');
          }

          // フォームを実際に送信
          form.submit();

          // 3秒後にフラグをリセット（送信エラー時のために）
          setTimeout(function() {
            isSubmitting = false;
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.style.pointerEvents = '';
              submitButton.style.opacity = '';
              console.log('  🔓 [フォーム' + index + '] ボタン再有効化（タイムアウト）');
            }
          }, 3000);
        });
      }, { capture: true });

      // 処理済みマーク
      submittingForms.add(form);
    });
  }

  // 初回実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      console.log('📍 [カート二重送信防止 & 在庫チェック] DOMContentLoaded');
      preventDoubleSubmit();
    });
  } else {
    // console.log('📍 [カート二重送信防止 & 在庫チェック] 即時実行');
    preventDoubleSubmit();
  }

  // 動的に追加されるフォームにも対応（MutationObserver）
  const observer = new MutationObserver(function(mutations) {
    let hasNewForms = false;
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          // 新しいフォームが追加されたかチェック
          if ((node.tagName === 'FORM' && node.getAttribute('data-type') === 'add-to-cart-form') ||
              (node.querySelector && node.querySelector('form[data-type="add-to-cart-form"]'))) {
            hasNewForms = true;
          }
        }
      });
    });

    if (hasNewForms) {
      console.log('🔄 [カート二重送信防止 & 在庫チェック] 新しいフォームを検出');
      preventDoubleSubmit();
    }
  });

  // body要素を監視開始
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    // console.log('👀 [カート二重送信防止 & 在庫チェック] フォーム監視を開始');
  }

  // console.log('✅ [カート二重送信防止 & 在庫チェック] 初期化完了');
})();

// ==========================================
// お気に入りページ: 商品名とカラー名を縦に表示
// ==========================================
(function() {
  // お気に入りページかどうかをチェック
  if (!window.location.pathname.includes('/apps/obake/favorites')) {
    return;
  }

  // console.log('💖 [お気に入り] 商品名の縦表示を初期化');

  function formatProductNames() {
    // .product-name-link 要素を全て取得
    const productNameLinks = document.querySelectorAll('.product-name-link');

    if (productNameLinks.length === 0) {
      // console.log('⏳ [お気に入り] 商品名リンクが見つかりません（再試行します）');
      return false;
    }

    // console.log('📋 [お気に入り] 商品名リンク数:', productNameLinks.length);

    productNameLinks.forEach(function(link, index) {
      // 既に処理済みの場合はスキップ
      if (link.dataset.formatted === 'true') {
        return;
      }

      const originalText = link.textContent.trim();

      // " - " で分割（商品名とカラー名の区切り）
      if (originalText.includes(' - ')) {
        const parts = originalText.split(' - ');
        const productName = parts[0].trim();
        const colorName = parts.slice(1).join(' - ').trim(); // 複数の " - " がある場合に対応

        // HTMLを再構築（改行で区切る）
        link.innerHTML = productName + '<br>' + colorName;
        link.dataset.formatted = 'true';

        // console.log('✅ [お気に入り' + (index + 1) + '] 縦表示に変更:', productName, '/', colorName);
      } else {
        // " - " がない場合はそのまま
        link.dataset.formatted = 'true';
        // console.log('⏭️ [お気に入り' + (index + 1) + '] 分割不要:', originalText);
      }
    });

    return true;
  }

  // 初回実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // console.log('📍 [お気に入り] DOMContentLoaded: 商品名フォーマット開始');
      setTimeout(formatProductNames, 500);
      setTimeout(formatProductNames, 1000);
      setTimeout(formatProductNames, 2000);
    });
  } else {
    // console.log('📍 [お気に入り] DOMContentLoaded済み: 商品名フォーマット開始');
    setTimeout(formatProductNames, 500);
    setTimeout(formatProductNames, 1000);
    setTimeout(formatProductNames, 2000);
  }

  // MutationObserverで動的に追加される商品にも対応
  const observer = new MutationObserver(function(mutations) {
    let hasNewLinks = false;
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          // 新しい .product-name-link が追加されたかチェック
          if ((node.classList && node.classList.contains('product-name-link')) ||
              (node.querySelector && node.querySelector('.product-name-link'))) {
            hasNewLinks = true;
          }
        }
      });
    });

    if (hasNewLinks) {
      // console.log('🔄 [お気に入り] 新しい商品名リンクを検出');
      setTimeout(formatProductNames, 100);
    }
  });

  // body要素を監視開始
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    // console.log('👀 [お気に入り] 商品名リンクの監視を開始');
  }

  // console.log('✅ [お気に入り] 商品名縦表示機能の初期化完了');
})();
